<template lang='pug'>
//- Verify-Page
div(:class='$style[`cc-verify-container`]')
  div(:class='$style[`cc-verify-banner`]')
    div(:class='$style[`cc-banner-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.font-doctor-theme 信箱
        span.font-normal-theme 驗證
        span.no-wrap 成功

      div.font-medium(:class='$style[`cc-banner-sub-title`]')
        span 立即體驗 Cancell醫抗癌 完整服務

    div(:class='$style[`cc-banner-button`]')
      router-link(
        role='button'
        tabindex='0'
        aria-label='返回Cancell首頁'
        :to='{ name: `index` }'
        :class='$style[`cc-verify-redirect`]'
        title='返回Cancell首頁') 返回首頁

    figure.graphic.graphic-verify(:class='$style[`cc-verify-graphic`]')


</template>

<script>
export default {
  metaInfo() {
    return {
      title: '信箱驗證成功',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/verify',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/verify',
      }],
    };
  },

  // components: {
  // },

  // data () {
  //   return {
  //   }
  // },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/info/verify.scss';
</style>
